<template>
  <b-form-group
    label="Adres"
    label-for="line1"
  >
    <b-form-input
      id="line1"
      v-model="itemData.line1"
      placeholder="Adres"
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'Title',
  components: { BFormGroup, BFormInput },
  computed: {
    itemData() {
      return this.$store.getters['footerContacts/dataItem']
    },
  },
}
</script>
